import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {SiteuserService} from '../../services/siteuser.service';
import {LanguageService} from '../../services/language.service'; 

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  @ViewChild('password', {static: true}) pswval: NgForm;

  formArr={username:'',useremail:'', userphone:'', userpass:''};
  rqsSuccessSts :boolean;
  rqsFailSts :boolean;
  showLang:string;
  errmsg:string = '';
  errmsg_ar:string = '';
  successMsg:string = '';
  isLoading:boolean;
  token:string;
  constructor(private router:Router,
     private usrObj:SiteuserService,private langObj:LanguageService) { 
      this.langObj.langStr.subscribe((data)=>{ 
        this.showLang = data;
      });
     }

  ngOnInit(): void {
    window.scroll(0,0);
    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }

  }

  onRegFormSubmit(regFrm:NgForm){
    this.isLoading = true;
    this.formArr.username = regFrm.value.username;
    this.formArr.useremail = regFrm.value.useremail;
    var userPhone = regFrm.value.userphone.replace(/^0+/, '');
    this.formArr.userphone = userPhone;
    this.formArr.userpass = regFrm.value.password;
    this.usrObj.siteuserRegistration(this.formArr).subscribe((data:any)=>{
      this.isLoading = false; 
      if (data.success){
        this.successMsg = data.message;
        this.rqsSuccessSts = true;
        this.rqsFailSts = false;
        localStorage.setItem('r_email', this.formArr.useremail);
        regFrm.reset();
        this.router.navigate(['register-verify']);
      }else{
        this.rqsFailSts = true;
        this.errmsg = data.message+data.data;
        this.errmsg_ar = data.message_ar;
      }
    },
    error=> {
      this.errmsg  = 'Internal Server Error.. You Registration could not be completed.';
      this.errmsg_ar  = 'خطأ داخلي في الخادم .. لا يمكن إكمال تسجيل الدخول';
      this.rqsFailSts = true;  
      this.isLoading = false;
    });
  }
}